<script lang="ts" setup>
defineOptions({ name: 'MSvgIcon' })

const props = withDefaults(defineProps<{
  // 显示的 svg 图标名称（剔除 icon-）
  name: string
  // 直接指定 svg 图标的颜色
  color?: string
  // 通过 tailwind 指定 svg 颜色的类名
  fillClass?: string
}>(), {
  color: '',
  fillClass: '',
})

// 真实显示的 svg 图标名（拼接 #icon-）
const symbolId = computed(() => `#icon-${props.name}`)
</script>

<template>
  <svg aria-hidden="true" :class="fillClass" :fill="color">
    <use :class="fillClass" :xlink:href="symbolId" :fill="color" />
  </svg>
</template>
